/**
 * Ammo-8 Palette
 * Created by rsvp asap.
 * https://lospec.com/palette-list/ammo-8
 */
export const colors = {
  offBlack: "#040c06",
  darkestGreen: "#112318",
  darkGreen: "#1e3a29",
  green1: "#305d42",
  green2: "#4d8061",
  lightGreen: "#89a257",
  lightestGreen: "#bedc7f",
  offWhite: "#eeffcc",
};
